const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#F6F8FA",
    minHeight: "100vh",
  },
  list: {
    backgroundColor: theme.palette.lightGrey.main,
    borderRadius: 5,
    listStyle: "none",
  },
  pannel: {
    backgroundColor: "#FFFFFF",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
    height: "100%",
  },
  banner: {
    backgroundColor: "#B85A00",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 900,
    padding: "15px",
    color: "white",
    borderRadius: "8px",
    // marginBottom: "10px",
  },
  // Point clignotant du badge « partie(s) en cours ». Jamais seul : il
  // accompagne toujours le libellé et son compteur.
  liveDot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
    flexShrink: 0,
    animation: "$pulse 1.6s ease-in-out infinite",
    "@media (prefers-reduced-motion: reduce)": {
      animation: "none",
    },
  },

  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.25 },
  },

  chartContainer: {
    height: "200px",
    width: "100%",
    position: "relative",
    marginTop: theme.spacing(2),
  },
  mainContent: {
    marginLeft: 180,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 80,
    },
  },
  playerReviewsContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    marginTop: "24px",
    padding: "16px",
    backgroundColor: "rgba(94, 119, 255, 0.05)",
    borderRadius: "12px",
    border: "1px solid rgba(94, 119, 255, 0.1)",
  },
  playerReviewsLabel: {
    color: "#4A63E8",
    fontWeight: 500,
    fontSize: "0.875rem",
  },
  playerReviewsPercentage: {
    color: "#4A63E8",
    fontWeight: 700,
    fontSize: "1.25rem",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  downloadAppButton: {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.darkGrey.main,
    textTransform: "none",
    borderRadius: "999px",
    padding: "4px 10px",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.12)",
    fontWeight: 800,
    fontSize: 12,
    minHeight: 30,
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    alignItems: "center",
    justifyContent: "center",
  },
  downloadAppDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  downloadAppDialogContent: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
  },
  downloadAppQrContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    backgroundColor: "#F9FAFB",
    borderRadius: theme.spacing(2),
    border: "1px solid #E5E7EB",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  downloadAppLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1),
    fontWeight: 700,
    color: "#2563EB",
    textDecoration: "none",
    wordBreak: "break-all",
    "&:hover": {
      textDecoration: "underline",
    },
    "&:focus-visible": {
      outline: "2px solid #2563EB",
      outlineOffset: 2,
      borderRadius: 4,
    },
  },
  // 3 boutons de l'en-tête (Tutoriel / Abonnement / Demande de fonctionnalité)
  headerActions: {
    flexWrap: "wrap",
    rowGap: 12,
    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-end",
    },
    "& .MuiButton-root": {
      whiteSpace: "nowrap",
      minHeight: 40,
    },
    "& .MuiButton-root:hover": {
      filter: "brightness(0.96)",
    },
    "& .MuiButton-root.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    "& .MuiButton-root:last-child": {
      color: "#B45309 !important",
    },
  },
  ctaPill: {
    maxWidth: "100%",
    transition: "transform 0.15s ease, filter 0.15s ease",
    "&:hover": {
      filter: "brightness(0.97)",
      transform: "translateY(-1px)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  // Boutons translucides des cartes « Module de paiement » et « Leaderboard »
  glassButton: {
    transition: "transform 0.2s ease, filter 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      filter: "brightness(1.1)",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #FFFFFF",
      outlineOffset: 2,
    },
  },
});

export default styles;
